import { Sparkles } from "lucide-react";
import type { SelectedSkill } from "../../api/types.js";

export function SkillIntentChip({
  selectedSkill,
  onClear,
  disabled = false
}: {
  selectedSkill: SelectedSkill;
  onClear: () => void;
  disabled?: boolean;
}) {
  return (
    <div className="composer-action-state">
      <div className="composer-skill-intent">
        <Sparkles size={13} />
        <span>{selectedSkill.displayName}</span>
        <button type="button" aria-label="清除已选择技能" onClick={onClear} disabled={disabled}>×</button>
      </div>
    </div>
  );
}
